import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import ClassesListComponent from "./components/ClassesListComponent";
import { useParams } from "react-router-dom";

const ClassesListPage = () => {
  //
  const listRef = useRef();
  const { schoolId, trainingId } = useParams();
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<SlotsBreadCrumb />}
        title="Liste des classes"
        subtitle="Gérer l'ensemble des classes de cette formation"
      >
        <ClassesListComponent
          ref={listRef}
          showAddButton={true}
          showFilterButton={true}
          schoolId={schoolId}
          trainingId={trainingId}
        />
      </MeaPage>
    </>
  );
};
export default ClassesListPage;
